/**
 * Global Configuration
 * Centralizes all environment variables following PROJECT_STRUCTURE_GUIDE.md pattern
 */

export const globalConfig = {
  /**
   * API Base URL for QMS Backend
   * Points to different environments based on build mode
   */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  
  /**
   * Default pagination settings
   */
  defaultPageNumber: Number(import.meta.env.VITE_DEFAULT_PAGE_NUMBER) || 1,
  defaultPageSize: Number(import.meta.env.VITE_DEFAULT_PAGE_SIZE) || 100,

  /**
   * Preview Questions Page Size
   * Number of questions to display per page in the preview/questions list
   */
  previewQuestionsPageSize: Number(import.meta.env.VITE_PREVIEW_QUESTIONS_PAGE_SIZE) || 50,

  /**
   * Max Question IDs (Preview)
   * Maximum number of question IDs allowed in CSV upload for preview
   */
  maxQuestionIds: Number(import.meta.env.VITE_MAX_QUESTION_IDS) || 200,

  /**
   * Google OAuth Client ID
   * Used for Google Sign-In integration
   */
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '911053632253-ncn420qgrrvoo8cpv5tfpmb415lfu1dr.apps.googleusercontent.com',

  /**
   * Google OAuth User Info Endpoint
   * Used to fetch user information after OAuth authentication
   */
  googleUserInfoUrl: import.meta.env.VITE_GOOGLE_USERINFO_URL ?? 'https://www.googleapis.com/oauth2/v3/userinfo',

  /**
   * Nagwa Email Domain
   * Required email domain for authentication
   */
  nagwaEmailDomain: import.meta.env.VITE_NAGWA_EMAIL_DOMAIN ?? '@nagwa.com',

  /**
   * Nagwa Questions Engine URL
   * JavaScript engine for rendering questions
   */
  questionsEngineUrl: import.meta.env.VITE_QUESTIONS_ENGINE_URL ?? 'https://classes-resources.nagwa.com/engines/unzipped/nagwa_questions_engine/index.html',

  /**
   * Engines Base Path
   * Base URL for engines (used in initFromPackage)
   */
  enginesBasePath: import.meta.env.VITE_ENGINES_BASE_PATH ?? 'https://classes-resources.nagwa.com/engines/unzipped',

  /**
   * Questions Base URL
   * Base URL for fetching question assets
   */
  questionsBaseURL: import.meta.env.VITE_QUESTIONS_BASE_URL ?? 'https://s3.us-east-1.amazonaws.com/beta-qms.nagwa.com/questions',

  /**
   * Job Questions Base URL
   * Base URL for fetching job-specific question assets
   */
  jobQuestionsBaseURL: import.meta.env.VITE_JOB_QUESTIONS_BASE_URL ?? 'https://s3.us-east-1.amazonaws.com/beta-qms.nagwa.com/jobs',

  /**
   * Iframe Question Batch Size
   * Number of questions to render in parallel batches
   */
  iframeQuestionBatchSize: Number(import.meta.env.VITE_IFRAME_QUESTION_BATCH_SIZE) || 10,
} as const;
